import React, { Fragment, useState } from 'react';
import I18n from '../../config/locales/e_i18n';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Backdrop, Button, Grid, Drawer } from '@material-ui/core';
import queryString from 'query-string';
import {
  DefaultHeader,
  HomeownerHeader,
  DistributorHeader
} from '../../components/common/Header';
import {
  Footer,
  FooterWithoutLanguageSwitch
} from '../../components/common/Footer';
import {
  getTrainingDashboardToken,
  getFleetDashBoardLink
} from '../AccountDetails/actions';
import {
  forwardTo,
  setToken,
  decodeToken,
  getToken,
  handleFeedbackMenu,
  getBelongsTo,
  constructQueryString,
  isCompanyIdValid,
  getEnvSpecificToken,
  isReferrerWhitelisted
} from '../../utils/helper';
import { get, isEmpty } from '../../utils/lodash';
import {
  setCompanyId,
  setMobileView,
  getCompanyInfo,
  getBannerData,
  setIsAdmin,
  setNoticeHeight,
  setEnlightenManagerToken,
  getABFeatureList,
  getUserDetails,
  getImageBannerData,
  getSiteDetails,
  getEnlightenVersionFooter
} from './actions';
import { getAccountData } from '../AccountDetails/actions';
import {
  getSystemDetails,
  setLeadDetails,
  setLeftPanelOpenList,
  getLeadDetails,
  getLeadFromJourneyId
} from '../LeadManagement/actions';
import Loader from '../../components/Loader';
import Breadcrumbs from '../../components/common/Breadcrumbs';
import LoggedAs from '../../components/LoggedAs';
import { getUserOwnPreferences } from '../Preferences/actions';
import analytics from '../../utils/analytics';
import BannerAlert from '../../components/BannerAlert';
import getMoment from '../../components/common/moment';
import LeadLeftPanelAccordion from '../../components/LeftPanelAccordion';
import settings from '../../utils/settings';
import feature from '../../utils/feature';
import {
  FLEET_DASHBOARD_URL,
  GENERATOR_TOKENS_URL
} from '../../config/constants';
import GoogleAnalytics from '../../utils/GoogleAnalytics/googleAnalytics4';
import SecurePrivacyButton from '../../components/SecurePrivacyButton';
import { getValue, removeKey, setValue } from '../../utils/localStorage';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5)
  },
  body: {
    paddingTop: theme.spacing(7),
    height: '100%'
  },
  mobileBody: {
    paddingTop: theme.spacing(6.25),
    height: '100%'
  },
  backdrop: {
    zIndex: `11 !important`,
    color: theme.palette.primary.main
  },
  systemMenuButton: {
    border: 'none',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    fontSize: 16,
    background: '#FAFAFA 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 15px #0000001a',
    margin: theme.spacing(2),
    position: 'fixed',
    zIndex: 1,
    '&:hover': {
      border: 'none',
      background: 'none'
    }
  },
  rightContainer: {
    height: '100%'
  },
  rightBody: {
    padding: 0,
    width: 'calc(100% - 280px)',
    marginLeft: theme.spacing(35),
    display: 'flex',
    flexDirection: 'column', 
  },
  noLeftPane: {
    padding: 0,
    width: '100%'
  },
  mobileRightBody: {
    width: '100%',
    marginLeft: theme.spacing(0),
    padding: theme.spacing(0, 2, 2.5),
    marginTop: theme.spacing(6)
  },
  leftAccordion: {
    padding: '0 !important',
    borderRight: '0.5px solid #3359773d',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 0px 15px #0000001A',
    position: 'fixed',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    height: 'calc(100% - 56px)',
    zIndex: 10
  },
  mobileLeftAccordion: {
    height: 'calc(100% - 45px)'
  },
  isMobileLeftAccordion: {
    position: 'relative',
    height: '100%'
  },
  rootWithLeftPanel: {
    padding: 0,
    flexGrow: 1
  }
}));

const Layout = ({
  children,
  isMobileView,
  currentlySending,
  matchProps,
  companyId,
  isAdmin,
  accountDetail,
  bannerNotice,
  preferencesData,
  isUnauthorized,
  accountLoading,
  isDashboard,
  withoutFooter,
  withoutLanguageSwitchFooter,
  hideBreadcrumb,
  fromIFrame,
  setNoticeHeight,
  companyInfo,
  enlightenManagerToken,
  belongsToAus,
  company,
  belongsToUs,
  showPage,
  fromITK,
  isMobile,
  hasLeftPane,
  currentlySendingForUserOwn,
  isHomeowner,
  isDistributor
}) => {
  const classes = useStyles();
  const [isLeftPaneOpen, setIsLeftPaneOpen] = useState(false);
  const { search, pathname } = matchProps.location;
  const { siteId = '' } = queryString.parse(search);
  hasLeftPane =
    pathname.includes('sgip-incentive') && !siteId ? false : hasLeftPane;
  const isLoading =
    accountLoading ||
    isUnauthorized ||
    currentlySending ||
    currentlySendingForUserOwn;
  const leftPaneAccordion = (
    <Grid
      className={clsx(
        classes.leftAccordion,
        isMobileView && classes.mobileLeftAccordion,
        isMobile && classes.isMobileLeftAccordion
      )}>
      <LeadLeftPanelAccordion
        isLeftPaneOpen={isLeftPaneOpen}
        isMobile={isMobile}
        closeLeftPanel={() => setIsLeftPaneOpen(false)}
        {...matchProps}
      />
    </Grid>
  );

  if (fromITK) {
    return (
      <Fragment>
        {accountLoading || isUnauthorized || currentlySendingForUserOwn ? (
          <Loader loading />
        ) : (
          <Box
            className={clsx(
              fromITK ? {} : isMobileView ? classes.mobileBody : classes.body
            )}>
            {!hideBreadcrumb && (
              <Breadcrumbs
                matchProps={matchProps}
                companyId={companyId}
                fromITK={fromITK}
              />
            )}
            {currentlySending && <Loader loading={currentlySending} />}
            {showPage && (
              <Box className={classes.root}>
                {!hasLeftPane ? (
                  <Fragment>{children}</Fragment>
                ) : (
                  <Fragment>
                    {isMobile && (
                      <Button
                        className={classes.systemMenuButton}
                        color='primary'
                        variant='outlined'
                        onClick={() => setIsLeftPaneOpen(true)}>
                        System Menu
                      </Button>
                    )}
                    <Grid
                      container
                      direction='row'
                      className={classes.rightContainer}>
                      {isMobile ? (
                        <Drawer
                          anchor='left'
                          open={isLeftPaneOpen}
                          onClose={() => setIsLeftPaneOpen(false)}>
                          {leftPaneAccordion}
                        </Drawer>
                      ) : (
                        leftPaneAccordion
                      )}
                      <Grid
                        className={clsx(
                          classes.rightBody,
                          isMobile && classes.mobileRightBody
                        )}>
                        {children}
                      </Grid>
                    </Grid>
                  </Fragment>
                )}
              </Box>
            )}
          </Box>
        )}
      </Fragment>
    );
  }
  return (
    <Fragment>
      {!fromIFrame &&
        (isHomeowner ? (
          <HomeownerHeader
            isMobileView={window.innerWidth < 768}
            {...matchProps}
          />
        ) : isDistributor ? (
          <DistributorHeader isAdmin={isAdmin} {...matchProps} />
        ) : (
          <DefaultHeader isAdmin={isAdmin} {...matchProps} />
        ))}
      {accountLoading || isUnauthorized || currentlySendingForUserOwn ? (
        <Loader loading />
      ) : (
        <Box className={isMobileView ? classes.mobileBody : classes.body}>
          {!hasLeftPane ? (
            <Fragment>
              <LoggedAs accountDetail={accountDetail} />
              {!fromIFrame && !isDashboard && !isEmpty(bannerNotice) && (
                <BannerAlert
                  bannerNotice={bannerNotice}
                  setNoticeHeight={setNoticeHeight}
                />
              )}
              {!fromIFrame && !hideBreadcrumb && (
                <Breadcrumbs matchProps={matchProps} companyId={companyId} />
              )}
              {(showPage || fromIFrame || hideBreadcrumb) && (
                <Box className={classes.root}>{children}</Box>
              )}
            </Fragment>
          ) : (
            <Fragment>
              {isMobile && !fromIFrame && (
                <Button
                  className={classes.systemMenuButton}
                  color='primary'
                  variant='outlined'
                  onClick={() => setIsLeftPaneOpen(true)}>
                  System Menu
                </Button>
              )}
              <Grid
                container
                direction='row'
                className={classes.rightContainer}>
                {isMobile && !fromIFrame ? (
                  <Drawer
                    anchor='left'
                    open={isLeftPaneOpen}
                    onClose={() => setIsLeftPaneOpen(false)}>
                    {leftPaneAccordion}
                  </Drawer>
                ) : !fromIFrame ? (
                  leftPaneAccordion
                ) : (
                  <Fragment />
                )}
                <Grid
                  className={clsx(
                    fromIFrame ? classes.noLeftPane : classes.rightBody,
                    isMobile && classes.mobileRightBody
                  )}>
                  <LoggedAs accountDetail={accountDetail} />
                  {!fromIFrame && !isDashboard && !isEmpty(bannerNotice) && (
                    <BannerAlert
                      bannerNotice={bannerNotice}
                      setNoticeHeight={setNoticeHeight}
                    />
                  )}
                  {!fromIFrame && !hideBreadcrumb && (
                    <Breadcrumbs
                      matchProps={matchProps}
                      companyId={companyId}
                    />
                  )}
                  {(showPage || fromIFrame || hideBreadcrumb) && (
                    <Box
                      className={clsx(classes.root, classes.rootWithLeftPanel)}>
                      {children}
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Fragment>
          )}
        </Box>
      )}
      {!fromIFrame && !withoutFooter && <Footer />}
      {!withoutLanguageSwitchFooter && <FooterWithoutLanguageSwitch />}
      {isLoading && <Backdrop className={classes.backdrop} open />}
      {!fromIFrame && <SecurePrivacyButton />}
    </Fragment>
  );
};

class DefaultLayout extends React.Component {
  constructor(props) {
    super(props);
    const { search, pathname } = props.location;
    let { token, ...remainingQuery } = queryString.parse(search);
    this.isAdmin = get(remainingQuery, 'isAdmin', false) || false;
    if(!token || !isReferrerWhitelisted()){
      token = getEnvSpecificToken();
    }
    const { company_id } = this.getCompanyUserId(token, pathname);
    const { is_distributor } = this.getIsDistributor(token, pathname);
    const companyIdFromParam = get(props, 'computedMatch.params.companyId');
    const companyId = companyIdFromParam ? companyIdFromParam : company_id;
    if (token && pathname) {
      setToken(token);
      const queryString = constructQueryString(remainingQuery);
      const forwardPathname = `${pathname}${queryString}`;
      forwardTo(forwardPathname);
    }

    if (
      is_distributor &&
      !pathname.includes('/manager/dashboard/account-details') &&
      !pathname.includes('/manager/dashboard/error')
    ) {
      window.location = '/manager/dashboard/distributor-dashboard';
    }

    if (
      pathname.includes('/manager/dashboard') &&
      !pathname.includes('/manager/dashboard/profiles') &&
      !pathname.includes('/manager/dashboard/activations') &&
      !pathname.includes('/manager/dashboard/company')
    ) {
      if (!pathname.includes(FLEET_DASHBOARD_URL) && companyId === null) {
        window.open(
          settings.enlightenMenuUrl(`dashboard?token=${getToken()}`),
          '_self'
        );
      }
    }

    if (token) this.props.setEnlightenManagerToken(token);
    // This change is done because user refreshes on solargraf quote and his preferences gets reset in reducer
    // so it seems like he doesnt have access to solargraf even though he has it
    // That is why this api is required to be called first and a loader is to be shown until it is successful
    // This change should be propagated to DRS although not necessary
    this.props.getUserOwnPreferences();

    this.props.setCompanyId(companyId);
    this.props.getAccountData({
      successCbk: () => this.accountSuccessCbk(companyId)
    });
    this.analytics = new analytics();
    const googleAnalytics = new GoogleAnalytics();
    const environments = settings.getConfig();
    googleAnalytics.setEnvironment(environments.env);
    this.systemDetailsUpdated = false;
    this.siteIdFromParam = '';
    this.state = {
      isMobile: window.innerWidth < 1024
    };
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  accountSuccessCbk = (companyId) => {
    const {
      accountDetail,
      getBannerData,
      getABFeatureList,
      getImageBannerData
    } = this.props;
    if (isCompanyIdValid(companyId)) {
      this.companyInfo(companyId);
    } else if(!this.props.location.pathname.includes('/manager/dashboard/company')){
      window.location = settings.enlightenMenuUrl('');
    }
    getBannerData();
    getImageBannerData();
    getABFeatureList({
      email: accountDetail.email,
      companyId: accountDetail.company_id
    });
    const installerName =
      get(accountDetail, 'first_name', '') +
      ' ' +
      get(accountDetail, 'last_name', '');
    this.analytics.setUserId(accountDetail.user_id, installerName, companyId);
  };

  companyInfo = (companyId) => {
    const { accountDetail, getCompanyInfo, setCompanyId, getUserDetails } =
      this.props;
    const companyIdFromParam = get(
      this.props,
      'computedMatch.params.companyId'
    );
    // give highest priority to companyIdFromParam as if I sign in as alpha solar and go to their branch i should their branch info
    companyId = companyIdFromParam
      ? companyIdFromParam
      : accountDetail.login_as
      ? accountDetail.company_id
      : companyId;
    setCompanyId(companyId);
    getUserDetails();
    if (companyId === null) {
      window.location = settings.enlightenMenuUrl('');
    } else {
      getCompanyInfo(companyId);
    }
  };

  getCompanyUserId = (token = '') => {
    const tokenValue = token || getToken();
    const { company_id } = decodeToken(tokenValue);
    return { company_id };
  };

  getIsDistributor = (token = '') => {
    const tokenValue = token || getToken();
    const { is_distributor } = decodeToken(tokenValue);
    return { is_distributor };
  };

  handleWindowSizeChange = () => {
    const isMobileView = window.innerWidth <= 1200;
    this.setState({ isMobile: window.innerWidth < 1024 });
    this.props.setMobileView(isMobileView);
  };

  componentDidMount = () => {
    this.handleWindowSizeChange();
    if (this.props.isAdmin || this.isAdmin === 'true') {
      this.props.setIsAdmin(true);
    } else {
      this.props.setIsAdmin(false);
    }
    this.props.getFleetDashBoardLink();
    this.checkIfSecurePrivacyEnabled();
  };

  checkIfSecurePrivacyEnabled() {
    // if (localStorage.getItem('is_secure_privacy_enabled')) {
    //   localStorage.removeItem('is_secure_privacy_enabled');
    // }
    this.waitForSecurePrivacySettingsLoad().then((settingsPage) => {
      localStorage.setItem('is_secure_privacy_enabled', true);
    });
  }

  waitForSecurePrivacySettingsLoad = () => {
    return new Promise((resolve) => {
      if (window.sp && window.sp.settingsPage) {
        resolve(window.sp.settingsPage);
      } else {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (window.sp && window.sp.settingsPage) {
              observer.disconnect();
              resolve(window.sp.settingsPage);
            }
          });
        });
        observer.observe(document.documentElement, {
          childList: true,
          subtree: true
        });
      }
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.featureList !== prevProps.featureList) {
      if (feature.isFeatureEnabled('ENLIGHTEN_VERSION_FOOTER')) {
        this.props.getEnlightenVersionFooter();
      }
      if (feature.isFeatureEnabled('TRAINING_DASHBOARD_FEATURE')) {
        this.props.getTrainingDashboardToken();
      }
    }
    const is_self_installer_grid_profile_enabled =
      !isEmpty(this.props.featureList) &&
      feature.isFeatureEnabled('GRID_PROFILE_SELF_INSTALLER_FEATURE_ID');
    if (
      this.props.location.pathname.includes('/manager/dashboard/profiles') &&
      this.props.accountDetail.self_installer !== undefined &&
      !isEmpty(this.props.featureList)
    ) {
      if (
        this.props.accountDetail.self_installer === true &&
        !is_self_installer_grid_profile_enabled
      ) {
        window.open(
          settings.enlightenMenuUrl(`dashboard?token=${getToken()}`),
          '_self'
        );
      }
    }
    handleFeedbackMenu(this.props);
    const {
      locale,
      countryCode,
      location,
      systemDetails,
      leadDetails = {},
      computedMatch = {},
      hasLeftPane,
      leftPanelOpenList,
      setLeftPanelOpenList,
      setLeadDetails,
      getSystemDetails,
      getLeadDetails,
      companyId,
      getSiteDetails,
      getLeadFromJourneyId
    } = this.props;
    I18n.defaultLocale = 'en';
    I18n.locale = locale || '';
    I18n.fallbacks = true;
    getBelongsTo(countryCode);
    getMoment(locale);
    const { search } = location;
    const { siteId = '' } = queryString.parse(search);
    if (!isEmpty(systemDetails)) {
      this.systemDetailsUpdated = true;
      const leadId = get(systemDetails, 'active_lead_id', '') || '';
      const linkedLeadJourneyId =
        get(systemDetails, 'linked_installer_lead_journey_id', '') || '';
      if (linkedLeadJourneyId && isEmpty(leadDetails)) {
        getLeadFromJourneyId({ leadJourneyId: linkedLeadJourneyId });
      } else if (!isEmpty(leadId)) {
        getLeadDetails({
          companyId: companyId,
          lead_id: leadId,
          journey_type: 'Turnkey',
          redirect: () => {}
        });
      }
    }
    const siteIdFromParam = get(computedMatch, 'params.source_id') || siteId;
    let leadLinkedSiteId = '';
    if (
      !isEmpty(leadDetails) &&
      !isEmpty(get(leadDetails, 'linked_site_id', ''))
    ) {
      leadLinkedSiteId = get(leadDetails, 'linked_site_id').toString();
    }
    if (
      hasLeftPane &&
      ((siteIdFromParam && !this.systemDetailsUpdated) ||
        (siteIdFromParam && siteIdFromParam !== this.siteIdFromParam) ||
        (leadLinkedSiteId && siteIdFromParam !== leadLinkedSiteId))
    ) {
      const openList = leftPanelOpenList.map((list) => {
        list.isOpen = false;
        return list;
      });
      setLeftPanelOpenList(openList);
      siteIdFromParam !== leadLinkedSiteId && setLeadDetails({});
      getSystemDetails({ siteId: siteIdFromParam });
      getSiteDetails({ siteId: siteIdFromParam });
      this.systemDetailsUpdated = true;
    }
    this.siteIdFromParam = siteIdFromParam;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  render() {
    const {
      component: Component,
      isMobileView,
      currentlySending,
      companyId,
      isAdmin,
      accountDetail,
      bannerNotice,
      preferencesData,
      isUnauthorized,
      accountLoading,
      isDashboard = false,
      withoutFooter = false,
      location,
      setNoticeHeight,
      companyInfo,
      enlightenManagerToken,
      belongsToAus,
      company,
      belongsToUs,
      showPage,
      hideBreadcrumb,
      hasLeftPane = false,
      currentlySendingForUserOwn,
      isHomeowner,
      fromITK,
      ...rest
    } = this.props;
    const { origin } = queryString.parse(location.search);
    const { isMobile } = this.state;
    const withoutFooterProp =
      window.location.pathname === FLEET_DASHBOARD_URL ||
      window.location.pathname === GENERATOR_TOKENS_URL
        ? true
        : withoutFooter;
    const withoutLanguageSwitchFooter =
      window.location.pathname === FLEET_DASHBOARD_URL ||
      window.location.pathname === GENERATOR_TOKENS_URL
        ? false
        : true;
    const isDistributor = accountDetail.is_distributor;
    return (
      <Route
        {...rest}
        render={(matchProps) => (
          <Layout
            isMobileView={isMobileView}
            currentlySending={currentlySending}
            companyId={companyId}
            bannerNotice={bannerNotice}
            matchProps={matchProps}
            isAdmin={isAdmin}
            accountDetail={accountDetail}
            preferencesData={preferencesData}
            isUnauthorized={isUnauthorized}
            accountLoading={accountLoading}
            isDashboard={isDashboard}
            withoutFooter={withoutFooterProp}
            withoutLanguageSwitchFooter={withoutLanguageSwitchFooter}
            setNoticeHeight={setNoticeHeight}
            fromIFrame={origin === 'iframe'}
            fromITK={fromITK}
            companyInfo={companyInfo}
            enlightenManagerToken={enlightenManagerToken}
            belongsToAus={belongsToAus}
            company={company}
            belongsToUs={belongsToUs}
            showPage={showPage}
            hideBreadcrumb={hideBreadcrumb}
            isMobile={isMobile}
            hasLeftPane={hasLeftPane}
            currentlySendingForUserOwn={currentlySendingForUserOwn}
            isHomeowner={isHomeowner}
            isDistributor={isDistributor}>
            <Component {...matchProps} fromIFrame={origin === 'iframe'} />
          </Layout>
        )}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setCompanyId: (companyId) => dispatch(setCompanyId(companyId)),
  getAccountData: (payloads) => dispatch(getAccountData(payloads)),
  setMobileView: (isMobileView) => dispatch(setMobileView(isMobileView)),
  setNoticeHeight: (noticeHeight) => dispatch(setNoticeHeight(noticeHeight)),
  getCompanyInfo: (companyId) => dispatch(getCompanyInfo(companyId)),
  getBannerData: () => dispatch(getBannerData()),
  getImageBannerData: () => dispatch(getImageBannerData()),
  setIsAdmin: (isAdmin) => dispatch(setIsAdmin(isAdmin)),
  setEnlightenManagerToken: (tokenVal) =>
    dispatch(setEnlightenManagerToken(tokenVal)),
  getABFeatureList: (payload) => dispatch(getABFeatureList(payload)),
  getUserDetails: () => dispatch(getUserDetails()),
  getUserOwnPreferences: () => dispatch(getUserOwnPreferences()),
  getSystemDetails: (payload) => dispatch(getSystemDetails(payload)),
  setLeadDetails: (leadDetails) => dispatch(setLeadDetails(leadDetails)),
  setLeftPanelOpenList: (payload) => dispatch(setLeftPanelOpenList(payload)),
  getLeadDetails: (payload) => dispatch(getLeadDetails(payload)),
  getSiteDetails: (payload) => dispatch(getSiteDetails(payload)),
  getLeadFromJourneyId: (payload) => dispatch(getLeadFromJourneyId(payload)),
  getTrainingDashboardToken: () => dispatch(getTrainingDashboardToken()),
  getFleetDashBoardLink: () => dispatch(getFleetDashBoardLink()),
  getEnlightenVersionFooter: () => dispatch(getEnlightenVersionFooter())
});

const mapStateToProps = (state) => ({
  isMobileView: state.appReducer.isMobileView,
  companyId: state.appReducer.companyId,
  currentlySending: state.appReducer.currentlySending,
  accountDetail: state.accountReducer.accountDetail,
  locale: state.accountReducer.locale,
  isUnauthorized: state.accountReducer.isUnauthorized,
  accountLoading: state.accountReducer.accountLoading,
  bannerNotice: state.appReducer.bannerNotice,
  isAdmin: state.appReducer.isAdmin,
  preferencesData: state.preferencesReducer.preferencesData,
  companyInfo: state.appReducer.companyInfo,
  enlightenManagerToken: state.appReducer.enlightenManagerToken,
  belongsToAus: state.appReducer.belongsToAus,
  company: state.appReducer.company,
  belongsToUs: state.appReducer.belongsToUs,
  showPage: state.appReducer.showPage,
  countryCode: state.appReducer.countryCode,
  systemDetails: state.leadReducer.systemDetails,
  leadDetails: state.leadReducer.leadDetails,
  leftPanelOpenList: state.leadReducer.leftPanelOpenList,
  currentlySendingForUserOwn:
    state.preferencesReducer.currentlySendingForUserOwn,
  isHomeowner: state.accountReducer.isHomeowner,
  fromITK: state.appReducer.fromITK,
  featureList: state.appReducer.featureList
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
